import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MM_YYYY } from '@web/common';
import { DateFormatPipe, RatingComponent } from '@web/shared/ui';

@Component({
  selector: 'app-public-box-tile-details',
  imports: [CommonModule, DateFormatPipe, RatingComponent],
  templateUrl: './public-box-tile-details.component.html',
  styleUrl: './public-box-tile-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBoxTileDetailsComponent {
  public readonly date = input.required<Date>();
  public readonly name = input.required<string>();
  public readonly rating = input.required<number>();
  public readonly votes = input.required<number>();

  protected readonly MM_YYYY = MM_YYYY;
}
